<template>
  <div id="playposit-offline-status">
    <!-- Are we Up? Or are we Down? ¯\_(⊙︿⊙)_/¯ -->
  </div>
</template>

<script>
export default {
  name: 'Offline',
  data() {
    return {
      serverUrl: this.$getServerUrl(),
    };
  },
  props: {
    readyToInject: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    readyToInject(newValue, oldValue) { // eslint-disable-line
      if (newValue) this.injectOfflineJs();
    },
  },
  methods: {
    injectOfflineJs() {
      const [
        offlineJsCss,
        offlineJsSource,
      ] = [
        `${this.serverUrl}hosted/offline-js/styles.css`,
        `${this.serverUrl}hosted/offline-js/offline.min.js`,
      ];
      this.$injectCssFile(offlineJsCss);
      this.$loadScript(offlineJsSource);
    },
  },
};
</script>
